module.exports = __webpack_public_path__ + "img/Emblem1.c579ebb4.png";